import { render } from "./SchemasTable.vue?vue&type=template&id=12b8b6ae"
import script from "./SchemasTable.vue?vue&type=script&lang=js"
export * from "./SchemasTable.vue?vue&type=script&lang=js"

import "./SchemasTable.vue?vue&type=style&index=0&id=12b8b6ae&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__